import React from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles';

type item = {
    id: number,
    customizedItemType: string,
    name: string,
    description: string,
    active: boolean
}

interface props {
    label: string;
    icon: string;
    items: item[]
}


const useStyles = makeStyles(theme =>
    createStyles({
        itemCard: {
            border: "0.5px solid #3449B0",
            height: "100%",
            padding: "12px",
            borderRadius: "4px"
        },
        itemCardHeader: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
        },
        itemCardBody: {
            marginTop: "12px",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gridTemplateRows: "1fr 1fr",
            gridAutoFlow: "column",
            "& span": {
                // marginBottom: "6px"
                color: "#1E1E1E80"
            }
        },
        icon: {
            marginRight: theme.spacing(1),
        },
        itemCardDisabled: {
            backgroundColor: "#F9F9F9",
            border: "0.5px solid #D3D7E8",
            height: "100%",
            padding: "12px",
            borderRadius: "4px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        }
    })
);

const CustomizedItemCard = ({ label, icon, items }: props) => {
    const classes = useStyles();


    return (
        <>
            {items.length > 0 ? <div className={classes.itemCard}>
                <div className={classes.itemCardHeader}>
                    <span style={{ fontWeight: "bold" }}>{label}</span>
                    <img src={"/" + icon} className={classes.icon} />
                </div>
                <div className={classes.itemCardBody}>
                    {items.map((item: item) => (<span>{item.name}</span>))}
                </div>
            </div> : <div className={classes.itemCardDisabled}>
                <img src={"/d_" + icon} style={{ marginBottom: "12px" }} />
                <span style={{ fontWeight: "bold", color: "#D3D7E8" }}>{label}</span>
            </div>}
        </>
    )
}

export default CustomizedItemCard;
